module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-500.020c97d.woff2";